module.exports = __webpack_public_path__ + "static/img/news_27.1711405.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/news_27.png
// module id = Rx5o
// module chunks = 2